import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import Button from '@mui/material/Button';

import { Box, Link } from '@mui/material';

import { THOR_COLORS } from '@/theme/thorTheme';
import Logo from './Logo';

export default function Header({ children }: { children?: React.ReactNode }) {
  return (
    <AppBar
      position="static"
      color="default"
      sx={{
        backgroundColor: THOR_COLORS.darkGreen,
        '--Paper-overlay': 'none',
        backgroundImage: 'none',
      }}
    >
      <Toolbar>
        <Logo />
        <Box sx={{ ml: 'auto' }}>
          {children}
          <Button
            color="inherit"
            endIcon={<ArrowOutwardIcon />}
            href="https://allenai.org/embodied-ai"
            target="_blank"
            sx={{ ml: 'auto', fontSize: '1.2rem' }}
            component={Link}
          >
            More embodied ai
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
